import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { CfpEngagementMemberContainerModel } from '../../../../../../models/aggregates/erp/index';

@Injectable({
  providedIn: 'root'
})
export class CfpEngagementMemberService extends BaseApiTemplateService<CfpEngagementMemberContainerModel> {

  static readonly CFP_ENGAGEMENT_MEMBER_SUBPATH = Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'cfp/engagement-members/';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpEngagementMemberService.CFP_ENGAGEMENT_MEMBER_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpEngagementMemberService.CFP_ENGAGEMENT_MEMBER_SUBPATH +
      BaseApiTemplateService.LOGIN_EP;
    this.httpClient = http;
  }
}
